export default __webpack_public_path__ + "static/media/logo.2bc8e4ee.png";